import React, { Fragment, useEffect, useState } from "react";
import { Row, Form, Col, Space, Typography, Radio, Button } from "antd";
import { connect } from "react-redux";
import ProfileViewPage from "./ProfileViewPage"
import SaveJobCardPage from "../../components/shared/saved-jobs-card/SaveJobsCard";
import HiringCardPage from "../../components/shared/hiring-card/HiringCard";
import PreviouseSearchCardPage from "../../components/shared/previous-search-card/PreviousSearchCard";
import { CustomeNotification } from "../../utils/NotificationUtility";
import { updatePersonPreference, updatePerson } from "../../services/common.service";
import { UserCacheUpdate } from "../../state/actions/auth";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { PhoneOutlined } from '@ant-design/icons';


const { Title, Text } = Typography;

export interface IProps {
    user?: any
    setSingupUser: (data: any) => void
}

const PreferencesPages: React.FC<any> = (props) => {
    const [form] = Form.useForm();
    const { updateUserCache, user } = props;
    const [phone, setPhone] = useState<string | undefined>(undefined);
    const [phoneInvalid, setPhoneInvalid] = useState(false);

    const sticky: React.CSSProperties = { position: 'sticky', top: '6em' }
    const boxStyle = { background: '#fff', padding: '2em', border: '1px solid #f0f0f0', borderRadius: '10px', marginBottom: '2em' }
    const textStyle = {
        background: '#fffbe6',
        padding: '1em',
        border: '1px solid #ffe58f',
        borderRadius: '10px',
        marginBottom: '2em'
    }

    useEffect(() => {
        const pref = user.preferences || {};
        form.setFieldsValue({ smsConsent: pref.sms || false });
        form.setFieldsValue({ whatsappConsent: pref.whatsup || false });
        form.setFieldsValue({ jobMatchAlert: pref.jobMatchAlert });
        if (user.phone) {
            setPhone(user.phone);
        }
    }, [user]);

    const setPhoneValue = (value?: string) => {
        setPhone(value || '');
        if (value && value.length > 5) {
            setPhoneInvalid(!isValidPhoneNumber(value));
        } else if (value && value.length) {
            setPhoneInvalid(false);
        } else {
            setPhoneInvalid(true);
        }
    };

    const onFormFinish = async (values: any) => {
        if (!phone || phoneInvalid) {
            setPhoneInvalid(true);
            return;
        }
        if (user && user._id) {
            const id = user._id;
            const prefObj: any = {
                sms: values.smsConsent,
                whatsup: values.whatsappConsent,
                jobMatchAlert: (values.jobMatchAlert == undefined) ? null : values.jobMatchAlert
            };

            await Promise.all([
                updatePersonPreference(id, prefObj),
                updatePerson(id, { phone })
            ]);

            const newPayload = { ...user, phone, preferences: prefObj };
            updateUserCache(newPayload);
            CustomeNotification('success', `Preferences Updated Successfully`);
        }
    };

    const onFinishFailed = (errorInfo: any) => {
        if (!phone || phoneInvalid) {
            setPhoneInvalid(true);
        }
    };

    const isSaveDisabled = !phone || phoneInvalid;

    return (
        <Fragment>
            <Row className="homeHeaderBg">
                <Col span={24}><h2>&nbsp;</h2></Col>
            </Row>

            <Row className="white-container profilePageWrapper">
                <Col span={24}>
                    <Row gutter={0}>
                        <Col xs={0} sm={0} md={0} lg={5} className="pa-2 pb-5 w-35X1300">
                            <div style={sticky}>
                                <HiringCardPage /><br />
                                <SaveJobCardPage />
                            </div>
                        </Col>
                        <Col sm={24} md={24} lg={14} className="pl-6 pr-6 pb-5 w-65X1300">

                            <Title level={3}>My Preferences</Title>

                            <div style={{ background: '#f7f8fa', padding: '1.2em', borderRadius: '1em' }}>
                                <Row style={boxStyle} className="profileWhiteWrapper">
                                    <Col xs={24} sm={22} md={22} lg={22}>
                                        <Space align="start" size={16} className="profileSpace">

                                            <Form
                                                name="prefrence_form"
                                                className="auth-form"
                                                autoComplete="off"
                                                layout='vertical'
                                                form={form}
                                                onFinish={onFormFinish}
                                                onFinishFailed={onFinishFailed}
                                            >


                                                <Form.Item name="textDec" style={{ marginBottom: "20px" }}>
                                                    <h3 style={{ marginTop: "5px", marginBottom: "5px" }}>Stay in the loop on your application</h3>
                                                    <p style={{ margin: 0 }}>We'd like to text you about your application and any opportunities that match your profile. Choose what you'd like to hear about - your selections are optional, and you can change them anytime from your profile.</p>
                                                    <h4 style={{ marginBottom: "5px" }}>Application Updates</h4>
                                                    <p style={{ margin: 0 }}>Status changes, interview invitations, and recruiter messages about roles you've applied to</p>
                                                </Form.Item>
                                                <Form.Item
                                                    label={<span>Phone Number <span style={{ color: 'red' }}>*</span></span>}
                                                    extra="We'll use this number to send SMS and WhatsApp notifications."
                                                    name="phone"
                                                    hasFeedback
                                                    validateTrigger={['onChange', 'onBlur']}
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Phone number is required!'
                                                        },
                                                        {
                                                            validator: (_, value) => {
                                                                if (!value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return isValidPhoneNumber(value)
                                                                    ? Promise.resolve()
                                                                    : Promise.reject(new Error('Please enter a valid phone number.'));
                                                            }
                                                        }
                                                    ]}
                                                >
                                                    <PhoneInput
                                                        international
                                                        addInternationalOption={false}
                                                        defaultCountry="US"
                                                        value={Form.useWatch('phone', form)}
                                                        onChange={(value) => form.setFieldsValue({ phone: value })}
                                                        className="input-phone-number"
                                                        placeholder="Enter phone start with country code"
                                                       
                                                    />
                                                </Form.Item>

                                                {/* <Form.Item
                                                    label={<span>Mobile Number <span style={{ color: 'red' }}>*</span></span>}
                                                    extra="We'll use this number to send SMS and WhatsApp notifications."
                                                    name="phone"
                                                    hasFeedback
                                                >
                                                    <PhoneInput
                                                        placeholder="Enter phone start with country code"
                                                        value={phone}
                                                        onChange={setPhoneValue}
                                                    />
                                                    {phoneInvalid && <Text type="danger">Invalid phone number</Text>}
                                                </Form.Item> */}


                                                <Form.Item name="smsConsent" style={{ marginBottom: "0" }} rules={[{ required: true, message: "Please select an option" }]}>
                                                    <Radio.Group>
                                                        <Radio value={true}>Yes, notify me by SMS</Radio>
                                                        <Radio value={false}>No, thanks</Radio>
                                                    </Radio.Group>
                                                </Form.Item>

                                                <Form.Item name="whatsappConsent" style={{ marginBottom: "0px" }} rules={[{ required: true, message: "Please select an option" }]}>
                                                    <Radio.Group>
                                                        <Radio value={true}>Yes, notify me on WhatsApp</Radio>
                                                        <Radio value={false}>No, thanks</Radio>
                                                    </Radio.Group>
                                                </Form.Item>

                                                <Form.Item name="textDec" style={{ marginBottom: "5px" }}>
                                                    <h4 style={{ marginBottom: "5px" }}>Job Match Alerts (optional)</h4>
                                                    <p style={{ margin: 0 }}>New roles that match your skills and preferences. This is promotional content.</p>
                                                </Form.Item>

                                                <Form.Item name="jobMatchAlert" style={{ marginBottom: "0px" }}>
                                                    <Radio.Group>
                                                        <Radio value={true}>Yes, notify me on WhatsApp</Radio>
                                                        <Radio value={false}>No, thanks</Radio>
                                                    </Radio.Group>
                                                </Form.Item>

                                                <Form.Item name="jobMatchAlert" style={{ marginBottom: "0px" }}>
                                                    <p style={textStyle}>
                                                        By selecting "Yes" above, you agree to receive recurring text messages from Service Global Inc at the number on your profile. Message frequency varies - typically 2-6 messages per week. Message and data rates may apply. Reply <strong>STOP</strong> to unsubscribe, <strong>HELP</strong> for help, or contact <a href="mailto:support@serviceglobal.com">support@serviceglobal.com</a>.
                                                        <br />
                                                        <a href="https://serviceglobal.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
                                                        {' | '}
                                                        <a href="https://serviceglobal.com/sms-terms/" target="_blank" rel="noreferrer">SMS Terms</a>
                                                    </p>
                                                </Form.Item>

                                                <Form.Item>
                                                    <Space>

                                                        <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            className={`login-form-button ${isSaveDisabled ? 'disabledBtn' : ''}`}
                                                            disabled={isSaveDisabled}
                                                        >
                                                            Save Preferences
                                                        </Button>

                                                    </Space>
                                                </Form.Item>
                                            </Form>

                                        </Space>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                        <Col xs={0} sm={0} md={0} lg={5} className="pa-2 width-100  pb-5 d-noneX1300">
                            <div style={sticky}>
                                <PreviouseSearchCardPage />
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Fragment>
    );
};

const mapStateToProps = (state: any) => {
    return { user: state.reducer.auth.user };
};

function mapDispatchToProps(dispatch: any) {
    return { updateUserCache: (payload: any) => dispatch(UserCacheUpdate(payload)) };
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesPages);
